// @flow
import { ALERT, HIDE_ALERT } from '../constants'

export const hideAlert = () => ({ type: HIDE_ALERT })

export const alert = (data: {
  message: string,
  klass?: string,
  timeout?: number
}) => ({ type: ALERT, ...data })



// WEBPACK FOOTER //
// ./src/actions/alert.js